import React from "react";
import {
  List,
  Datagrid,
  TextField,
  Filter,
  FunctionField,
  NullableBooleanInput,
  SelectInput,
  useUpdate,
  useNotify,
  useRefresh,
  Pagination,
} from "react-admin";
import { Switch } from "@mui/material";

const PaymentChannelDisplayPagination = () => (
  <Pagination rowsPerPageOptions={[5, 10, 25]} />
);

const StatusSwitch = ({ record }: { record: any }) => {
  const [update, { isLoading }] = useUpdate();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSwitchChange = () => {
    update(
      "paymentChannelDisplay",
      { id: record.id, data: { status: !record.status }, previousData: record },
      {
        onSuccess: () => {
          notify("Status updated successfully", { type: "info" });
          refresh();
        },
        onError: () => {
          notify("Error updating status", { type: "warning" });
        },
      }
    );
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <Switch
        checked={record.status}
        onChange={handleSwitchChange}
        color="primary"
        disabled={isLoading}
        inputProps={{ "aria-label": "primary checkbox" }}
      />
      {record.status ? "ACTIVE" : "INACTIVE"}
    </div>
  );
};

const PaymentChannelDisplayFilter = (props: any) => (
  <Filter {...props}>
    <SelectInput
      label="Country"
      source="country"
      alwaysOn
      choices={[
        { id: "HK", name: "HONG KONG" },
        { id: "TW", name: "TAIWAN" },
      ]}
    />
    <SelectInput
      label="Status"
      source="status"
      alwaysOn
      choices={[
        { id: true, name: "ACTIVE" },
        { id: false, name: "INACTIVE" },
      ]}
    />
  </Filter>
);

export const PaymentChannelDisplayList = (props: any) => (
  <List
    {...props}
    resource="paymentChannelDisplay"
    title="Services &rsaquo; Payment Channel Display"
    filters={<PaymentChannelDisplayFilter />}
    exporter={false}
    pagination={<PaymentChannelDisplayPagination />}
    perPage={5}
  >
    <Datagrid bulkActionButtons={false}>
      <TextField source="channel" label="Channel Name" />
      <TextField source="country" label="Country" />
      <FunctionField
        label="Status"
        render={(record: any) => <StatusSwitch record={record} />}
      />
    </Datagrid>
  </List>
);
